import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css';
import vuetify from './plugins/vuetify';
import Vuelidate from "vuelidate";

Vue.use(Vuelidate);
Vue.use(VueMaterial);
Vue.use(vuetify);


Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');
